import React from "react";

export const StatCard = ({ label, value, icon: Icon, accent = "blue", helper }) => {
  const accents = {
    blue: "from-blue-50 to-blue-100 text-blue-700",
    amber: "from-amber-50 to-amber-100 text-amber-700",
    emerald: "from-emerald-50 to-emerald-100 text-emerald-700",
    rose: "from-rose-50 to-rose-100 text-rose-700",
    slate: "from-slate-50 to-slate-100 text-slate-700",
  };

  return (
    <div className="guardian-card stat-card bg-white">
      <div className="stat-header">
        <div className="stat-content">
          <p className="stat-label">{label}</p>
          <p className="stat-value">{value}</p>
          {helper && <p className="mt-2 text-xs text-[#64748B]">{helper}</p>}
        </div>
        {Icon && (
          <div className={`stat-icon bg-gradient-to-br ${accents[accent] || accents.blue}`}>
            <Icon size={20} />
          </div>
        )}
      </div>
    </div>
  );
};

export default StatCard;
